import { Customer } from "../../classes";
import moment from "moment";
import Helper from "../../plugins/Helper/Helper";
import i18n from '@/plugins/vue-i18n'
const CustomerModule = {
  namespaced: true,
  state: {
    customers: [],
    search: "",
    customer: {},
    searchCustomers: [],
    projectCustomers: [],
    projectCustomerCount: 0
  },
  actions: {
    getCustomers: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Customer.getCustomersByMarket({
          marketId: rootGetters["markets/getMarketId"]
        });
        commit("setCustomers", { customer: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createCustomer: async ({ dispatch, commit, rootGetters }, payload) => {
      try {
        const newObj = {
          ...payload,
          marketId: rootGetters["markets/getMarketId"],
          projectId: rootGetters["markets/getProjectId"],
          incomePerYear: parseFloat(payload.incomePerYear),
          businessStartYear: parseInt(payload.businessStartYear),
          rentalStartYear: parseInt(payload.rentalStartYear),
          dateOfBirth: moment(payload.dateOfBirth).startOf("day"),
          citizenCardExpiryDate: moment(payload.citizenCardExpiryDate).endOf(
            "day"
          ),
          citizenCardIssueDate: moment(payload.citizenCardIssueDate).startOf(
            "day"
          )
        };

        const data = await Customer.createCustomer(newObj);
        commit("addCustomer", data);
        commit("addProjectCustomer", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomer: async ({ commit }, payload) => {
      try {
        const data = await Customer.getCustomer({ id: payload.id });
        commit("setCustomer", { customer: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateCustomer: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
          incomePerYear: parseFloat(payload.incomePerYear),
          businessStartYear: parseInt(payload.businessStartYear),
          rentalStartYear: parseInt(payload.rentalStartYear),
          dateOfBirth: moment(payload.dateOfBirth).startOf("day"),
          citizenCardExpiryDate: moment(payload.citizenCardExpiryDate).endOf(
            "day"
          ),
          citizenCardIssueDate: moment(payload.citizenCardIssueDate).startOf(
            "day"
          )
        };
        const data = await Customer.updateCustomer(newObj);
        commit("setCustomer", { customer: data });
        commit("updateProjectCustomer", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomerByKeyword: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const data = await Customer.getCustomerByKeyword({
          keyword: payload.keyword,
          projectId: rootGetters["markets/getProjectId"]
        });
        commit("setSearchCustomer", { customer: data });
        commit("setProjectCustomers", data);
        return data;
      } catch (err) {
        return false;
      }
    },
    getCustomersByProject: async (
      { commit },
      { projectId, limit, page, order }
    ) => {
      try {
        const data = await Customer.getCustomersByProject(
          projectId,
          limit,
          page,
          order
        );
        commit("setProjectCustomers", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomersLengthByProject: async ({ commit }, { projectId }) => {
      try {
        const data = await Customer.getCustomersLengthByProject(projectId);
        commit("setProjectCustomerCount", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    checkTaxID: async ({ commit }, payload) => {
      try {
        let response = await Customer.checkTaxID(payload);
        if (payload.isVat && response) {
          response.companyName = `${response.TitleName} ${response.Name}${response.Surname != '-' ? ' ' + response.Surname : ''}`
          response.HouseNumber = response.HouseNumber.replace(/ /g, "");
          response.BuildingName = response.BuildingName.replace(/ /g, "");
          response.RoomNumber = response.RoomNumber.replace(/ /g, "");
          response.FloorNumber = response.FloorNumber.replace(/ /g, "");
          response.StreetName = response.StreetName.replace(/ /g, "");
          response.SoiName = response.SoiName.replace(/ /g, "");
          response.VillageName = response.VillageName.replace(/ /g, "");
          response.MooNumber = response.MooNumber.replace(/ /g, "");
          response.HouseNumberText = response.HouseNumber != '-' ? `${i18n.t('number')} ${response.HouseNumber}` : ''
          response.BuildingNameText = response.BuildingName != '-' ? `${i18n.t('building')} ${response.BuildingName}` : ''
          response.RoomNumberText = response.RoomNumber != '-' ? `${i18n.t('room_number')} ${response.RoomNumber}` : ''
          response.FloorNumberText = response.FloorNumber != '-' ? `${i18n.t('floor')} ${response.FloorNumber}` : ''
          response.StreetNameText = response.StreetName != '-' ? `${i18n.t('street')} ${response.StreetName}` : ''
          response.SoiNameText = response.SoiName != '-' ? `${i18n.t('soi')} ${response.SoiName}` : ''
          response.VillageNameText = response.VillageName != '-' ? `${i18n.t('village_name')} ${response.VillageName}` : ''
          response.MooNumberText = response.MooNumber != '-' ? `${i18n.t('moo_number')} ${response.MooNumber}` : ''
          response.addressStreet = `${response.HouseNumberText}${response.BuildingNameText}${response.RoomNumberText}${response.FloorNumberText}${response.SoiNameText}${response.StreetNameText}${response.VillageNameText}${response.MooNumberText}`;
          response.addressSubDistrict = response.Thambol ? `${i18n.t('sub_district_or_district')} ${response.Thambol}` : ''
          response.addressDistrict = response.Amphur ? `${i18n.t('amphoe_or_zone')} ${response.Amphur}` : ''
          response.addressProvince = response.Province ? `${i18n.t('province')} ${response.Province}` : '';
          response.addressZipcode = response.PostCode ? `${i18n.t('postal_code')} ${response.PostCode}` : '';
          response.fullAddress = `${response.addressStreet} ${response.addressSubDistrict} ${response.addressDistrict} ${response.addressProvince} ${response.addressZipcode}`

          response.ststusChecked = { text: '', icon: '', color: '', value: '' }
          if (response.msgerr == '-') {
            response.ststusChecked.value = 'checked'
            response.ststusChecked.color = 'success'
            response.ststusChecked.text = i18n.t('validate.registration_data_found')
            response.ststusChecked.icon = 'mdi-shield-check-outline'
          } else {
            response.ststusChecked.value = 'error'
            response.ststusChecked.color = 'error'
            response.ststusChecked.text = i18n.t('validate.registration_data_not_found')
            response.ststusChecked.icon = 'mdi-shield-off-outline'
          }
        } else if (!payload.isVat && response) {
          response.DigitOkText = response.DigitOk == 'True' ? i18n.t('correct') : i18n.t('incorrect')
          response.IsExistText = response.IsExist == 'Yes' ? i18n.t('have') : i18n.t('no')

          response.ststusChecked = { text: '', icon: '', color: '', value: '' }
          if (response.DigitOk == 'True' && response.IsExist == 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'checked'
            response.ststusChecked.color = 'success'
            response.ststusChecked.text = i18n.t('found_data')
            response.ststusChecked.icon = 'mdi-shield-check-outline'
          } else if (response.MessageErr != '-') {
            response.ststusChecked.value = 'error'
            response.ststusChecked.color = 'error'
            response.ststusChecked.text = i18n.t('not_found_data')
            response.ststusChecked.icon = 'mdi-shield-off-outline'
          } else if (response.DigitOk == 'True' && response.IsExist != 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'DigitOk'
            response.ststusChecked.color = 'warning'
            response.ststusChecked.text = i18n.t('validate.found_data_correct_but_not_in_rd_web_service')
            response.ststusChecked.icon = 'mdi-shield-alert-outline'
          } else if (response.DigitOk != 'True' && response.IsExist == 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'IsExist'
            response.ststusChecked.color = 'warning'
            response.ststusChecked.text = i18n.t('validate.found_data_incorrect_but_in_rd_web_service')
            response.ststusChecked.icon = 'mdi-shield-alert-outline'
          }
        }
        return response;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getCustomers: state =>
      state.customers.map(i => {
        i.customerMarketId =
          i?.contracts?.[0]?.customerMarketId ||
          i?.contracts?.[1]?.customerMarketId ||
          i?.contracts?.[2]?.customerMarketId ||
          "-";
        i.erpId = i.erpId || "-";
        i.contractLabel = i.contracts.map(i => i.contractId).join(",");
        i.businessName = i.businessName || "-";
        i.emails = i.emails.length > 0 ? i.emails : ["-"];
        i.tels = i.tels.length > 0 ? i.tels : ["-"];
        i.interTels = i.interTels.length > 0 ? i.interTels : ["-"];
        i.fullName = i.firstName ? i.firstName + " " + i.lastName : "-";
        return i;
      }),
    getSearchCustomers: state =>
      state.searchCustomers.map(i => {
        i.label = i.labelSearch;
        return i;
      }),
    getCustomerId: state => state.customer?.customerId,
    getCustomerObjectId: state => state.customer?.objectId,
    getCustomer: state => state.customer,
    getFullName: state =>
      `${state.customer?.firstName} ${state.customer?.lastName}`,
    getGlobalId: state => ({
      erpId: state.customer.erpId,
      internalId: state.customer.internalId
    }),
    getCustomerContract: state => state.customer.contracts || false,
    getAddressArray: state => {
      if (state.customer.type == "personal") {
        return [
          {
            text:
              `[${i18n.t('account.citizen_card')}] ` +
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode,
            value:
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode
          },
          {
            text:
              `[${i18n.t('account.house_registration')}] ` +
              state.customer?.addressHouseStreet +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressHouseSubDistrict +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressHouseDistrict +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressHouseProvince +
              " " +
              state.customer?.addressHouseZipcode,
            value:
              state.customer?.addressHouseStreet +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressHouseSubDistrict +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressHouseDistrict +
              " " +
              `${state.customer?.addressHouseProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressHouseProvince +
              " " +
              state.customer?.addressHouseZipcode
          },
          {
            text:
              `[${i18n.t('account.contact_address')}] ` +
              state.customer?.addressContactStreet +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressContactSubDistrict +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressContactDistrict +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressContactProvince +
              " " +
              state.customer?.addressContactZipcode,
            value:
              state.customer?.addressContactStreet +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressContactSubDistrict +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressContactDistrict +
              " " +
              `${state.customer?.addressContactProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressContactProvince +
              " " +
              state.customer?.addressContactZipcode
          }
        ];
      } else if (state.customer.type == "company") {
        return [
          {
            text:
              `[${i18n.t('customer.company_address')}] ` +
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode,
            value:
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('sub_district')
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? i18n.t('district')
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == i18n.t('bangkok')
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode
          }
        ];
      }
    },
    getCustomerBanking: state => {
      return state.customer?.bankAccounts;
    }
  },
  mutations: {
    setSearchCustomer: (state, payload) => {
      state.searchCustomers = payload.customer;
    },
    setCustomer: (state, payload) => {
      state.customer = payload.customer;
    },
    setCustomers: (state, payload) => {
      state.customers = payload.customer;
    },
    addCustomer(state, customer) {
      state.customers.unshift(customer);
    },
    setSearch(state, payload) {
      state.search = payload.search;
    },
    setProjectCustomers(state, customers) {
      state.projectCustomers = customers;
    },
    addProjectCustomer(state, customer) {
      state.projectCustomers.unshift(customer);
      state.projectCustomerCount++;
    },
    updateProjectCustomer(state, customer) {
      if (state.projectCustomers) {
        let index = state.projectCustomers.findIndex(
          i => i.objectId === customer.objectId
        );
        if (index > 0) state.projectCustomers[index] = customer;

        const temp = state.projectCustomers;
        state.projectCustomers = [];
        state.projectCustomers = temp;
      }
    },
    setProjectCustomerCount(state, count) {
      state.projectCustomerCount = count || 0;
    }
  }
};
export default CustomerModule;
